import React, { useState } from 'react'
import ExchangeView from '@modules/Swap/ExchangeView'
import { ConvertProvider, useConvertContext } from '@plug-core/providers/ConvertProvider'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import BottomSheet from '@components/BottomSheet'
import ConvertReview from './Components/ConvertReview'
import ErrorPopup from '@components/ErrorPopup'
import useConvert from '@plug-core/hooks/useConvert'

const ConvertTokenSelect = () => {
  const [convertError, setConvertError] = useState<string>()
  const [reviewVisible, setReviewVisible] = useState<boolean>(false)

  const { state } = useLocation()
  const { t } = useTranslation()

  const { getTokenById, tokens, destinationTokens, error } = useConvert({
    fromTokenId: state?.fromTokenId,
  })

  const { setFromToken, fromToken, toToken, setToToken, amount, setAmount, toAmount, setToAmount } =
    useConvertContext()

  const onErrorClose = () => {
    setReviewVisible(false)
    setConvertError(undefined)
  }

  return (
    <ExchangeView
      setFromToken={(id) => setFromToken(getTokenById(id))}
      toToken={toToken}
      setToToken={(id) => setToToken(getTokenById(id))}
      fromToken={fromToken}
      amount={amount}
      setAmount={setAmount}
      toAmount={toAmount}
      setToAmount={setToAmount}
      tokens={tokens}
      destinationTokens={destinationTokens}
      error={error}
      nextTitle={t('convert.startConversion')}
      handleSubmit={() => setReviewVisible(true)}
      mode="convert"
      chainMode="all"
      setChainMode={() => {}}
      chains={[]}
    >
      <BottomSheet visible={reviewVisible} onBackdropClick={() => setReviewVisible(false)}>
        <ConvertReview onError={setConvertError} />
      </BottomSheet>
      <ErrorPopup
        visible={!!convertError}
        title="Convert Failed"
        description={convertError?.toString()}
        onDismiss={onErrorClose}
      />
    </ExchangeView>
  )
}

export const Convert = () => (
  <ConvertProvider>
    <ConvertTokenSelect />
  </ConvertProvider>
)
